module.exports = __webpack_public_path__ + "img/belgium-flag.930b48e.png";